import { ILoggingSettings } from "@multiweb/logging";
import { IDevelopmentSettings, IInitParams } from "./IInitParams";

/**
 * Konfigurační třída představující objekt s InitParams
 */
export class AppConfigurationBase implements Readonly<IInitParams> {
    // property převzaté z IInitParams, bez skutečných implementací a hodnot
    // anotace ts-ignore jsou potřeba pro striktní kompilaci, která nepozná, že se jedná o proxy a vlastnosti ve skutečnosti nejsou potřeba

    // @ts-ignore
    public readonly appName: string;
    // @ts-ignore
    public readonly clientCode: string;
    // @ts-ignore
    public readonly reportType: string;
    // @ts-ignore
    public readonly formUI: string;
    // @ts-ignore
    public readonly heartBeatInterval: number;
    // @ts-ignore
    public readonly heartBeatTimeout: number;
    // @ts-ignore
    public readonly developmentMode: boolean | IDevelopmentSettings;
    // @ts-ignore
    public readonly logging: ILoggingSettings;
    // @ts-ignore
    public readonly userActionLoggerInterval: number;
    // @ts-ignore
    public readonly openedFormsHistoryCount: number;
    // @ts-ignore
    public readonly forceIdsInSelectAllConditionThreshold: number;
    // @ts-ignore
    public readonly webServiceUrl: string;
    // @ts-ignore
    public readonly showMainMenuExpanded: boolean;
    // @ts-ignore
    public readonly showMainMenuCaptions: boolean;
    // @ts-ignore
    public readonly legacyActiveRoles: boolean;
    // @ts-ignore
    public readonly defaultShowSettings: boolean;
    // @ts-ignore
    public readonly preloadFormCount: number;
    // @ts-ignore
    public readonly defaultMenuItemsIcon: string;

    // @ts-ignore
    public get defaultWhisperer(): string;
    // @ts-ignore
    public get defaultFilter(): string;

    // skutečný obsah třídy začíná zde

    protected readonly _initParams: Readonly<IInitParams>;

    constructor(initParams: IInitParams) {
        this._initParams = initParams;

        // přístup k původním initParams zabezpečuje Proxy
        const handler: ProxyHandler<this> = {
            get: (_target: this, property: PropertyKey) => this._handleGetProperty(this._initParams, property),
            set: (_target: this, property: PropertyKey, value: any) => this._handleSetProperty(this._initParams, property, value),
            has: (_target: this, property: PropertyKey) => this._handlegetHas(this._initParams, property),
            ownKeys: (_target: this) => this._handleOwnKeys(this._initParams),
            getOwnPropertyDescriptor: (_target: this, property: PropertyKey) => this._handlegetOwnPropertyDescriptor(this._initParams, property),
        };

        return new Proxy(this, handler);
    }

    private _handleGetProperty(target: Readonly<IInitParams>, property: PropertyKey): any {
        if (Reflect.has(this, property))
            return Reflect.get(this, property);

        return Reflect.get(target, property);
    }

    private _handleSetProperty(_target: Readonly<IInitParams>, property: PropertyKey, value: any): boolean {
        if (Reflect.has(this, property))
            return Reflect.set(this, property, value);

        throw new Error(`Unable to set readonly property '${property.toString()}`);
    }

    private _handleOwnKeys(target: Readonly<IInitParams>): (string | symbol)[] {
        return [...Reflect.ownKeys(target), ...Reflect.ownKeys(this)].filter(key => typeof key !== "string" || !key.startsWith("_"));
    }

    private _handlegetOwnPropertyDescriptor(target: Readonly<IInitParams>, property: PropertyKey): PropertyDescriptor | undefined {
        return Reflect.getOwnPropertyDescriptor(this, property) ?? Reflect.getOwnPropertyDescriptor(target, property);
    }

    private _handlegetHas(target: Readonly<IInitParams>, property: PropertyKey): boolean {
        return Reflect.has(this, property) || Reflect.has(target, property);
    }
}
